import Route from 'react-router/lib/Route';
import Redirect from 'react-router/lib/Redirect';
import IndexRoute from 'react-router/lib/IndexRoute';
import IndexRedirect from 'react-router/lib/IndexRedirect';

import meQuery from './queries/MeQuery';
//import organisationQuery from './queries/OrganisationQuery';
import React from 'react';

import HomePage from './home/HomePage.react.js';
import SignIn from './app/SignIn.react';
/* organisation */
import OrganisationList from './organisations/OrganisationList.react.js';
import OrganisationAdd from './organisations/OrganisationAdd.react.js';
import OrganisationEdit from './organisations/OrganisationEdit.react.js';
import OrganisationView from './organisations/OrganisationView.react.js';
import OrganisationHooks from './organisations/OrganisationHooks.react.js';
import OrganisationBilling from './organisations/OrganisationBilling.react.js';
import OverdueBillsPage from './admin/overdue-bills/OverdueBillsPage.react.js';
import OrganisationRunningJobList from './running-jobs/OrganisationRunningJobList.react.js';

/* tariffs */
import TariffList from './tariffs/TariffList.react.js';
import TariffEdit from './tariffs/TariffEdit.react.js';
import TariffAdd from './tariffs/TariffAdd.react.js';

import UsedScenarioList from './organisations/UsedScenarioList.react';
import ScenarioOrganisationList from './organisations/ScenarioOrganisationList.react.js';

/* organisation2user */
import Organisation2UserEdit from './organisation2user/Organisation2UserEdit.react';
import Organisation2UserList from './organisation2user/Organisation2UserList.react';

/* organisationEvents */
import OrganisationEventList from './organisation-events/OrganisationEventList.react';
import ChannelEventList from './organisation-events/ChannelEventList.react';
import FlowEventList from './organisation-events/FlowEventList.react';

/* organisationNotifications */
import OrganisationNotificationList from './organisation-notifications/OrganisationNotificationList.react';
import OrganisationNotificationView from './organisation-notifications/OrganisationNotificationView.react';
import ConsultantNotificationList from './organisation-notifications/ConsultantNotificationList.react';

/* users */
//import UserList from './users/UserList.react.js';
import UserEdit from './users/UserEdit.react.js';
import UserView from './users/UserView.react.js';

/* invitations */
import InvitationList from './invitations/InvitationList.react.js';
import InvitationView from './invitations/InvitationView.react.js';
import InvitationAdd from './invitations/InvitationAdd.react.js';
import InvitationAccept from './invitations/InvitationAccept.react';

/* api keys */
import ApiKeyList from './api-keys/ApiKeyList.react.js';
import ApiKeyView from './api-keys/ApiKeyView.react.js';
import ApiKeyAdd from './api-keys/ApiKeyAdd.react.js';
import ApiKeyEdit from './api-keys/ApiKeyEdit.react.js';

/* channels */
import ChannelView from './channels/ChannelView.react.js';
import ChannelLogger from './channels/ChannelLogger.react.js';
import ChannelGranted from './channels/ChannelGranted.react.js';
import ChannelGrantedInPanel from './channels/ChannelGrantedInPanel.react.js';
import ChannelEdit from './channels/ChannelEdit.react.js';
import ChannelAdd from './channels/ChannelAdd.react.js';
import ChannelAddAuto from './channels/ChannelAddAuto.react.js';
import ChannelAddStep1 from './channels/ChannelAddStep1.react.js';
import ChannelAddStep2 from './channels/ChannelAddStep2.react.js';
import ChannelAddStep3 from './channels/ChannelAddStep3.react.js';
import ChannelAddStep4 from './channels/ChannelAddStep4.react.js';
import ChannelAddStep5 from './channels/ChannelAddStep5.react.js';
import ChannelOptionEdit from './channels/ChannelOptionEdit.react';
import SetChannelConfidential from './channels/SetChannelConfidential.react';
import ActivateChannelCaching from './channels/ActivateChannelCaching.react';
import ApplicationAddonDetail from "./channels/ShoptetApplicationDetail.react";

/* screens */
import ScreenView from './screens/ScreenView.react.js';
import ScreenEdit from './screens/ScreenEdit.react.js';
import ScreenAdd from './screens/ScreenAdd.react.js';
import ScreenList from './screens/ScreenList.react.js';

/* channel addons */
import ChannelAddonView from './channel-addons/ChannelAddonView.react.js';
import ChannelAddonEdit from './channel-addons/ChannelAddonEdit.react.js';
import ChannelAddonConfig from './channel-addons/ChannelAddonConfig.react.js';
import ChannelAddonList from './channel-addons/ChannelAddonList.react.js';
import ChannelAddonAdd from './channel-addons/ChannelAddonAdd.react.js';
import ChannelAddonAddStep1 from './channel-addons/ChannelAddonAddStep1.react.js';
import ChannelAddonAddStep2 from './channel-addons/ChannelAddonAddStep2.react.js';

/* Relation definitions */
import RelationDefView from './relation/RelationDefView.react.js';
import RelationDefEdit from './relation/RelationDefEdit.react.js';
import RelationDefAdd from './relation/RelationDefAdd.react.js';
import RelationDefList from './relation/RelationDefList.react.js';

/* Relation definitions */
import BillingRuleView from './billing-rules/BillingRuleView.react.js';
import BillingRuleEdit from './billing-rules/BillingRuleEdit.react.js';
import BillingRuleAdd from './billing-rules/BillingRuleAdd.react.js';
import BillingRuleList from './billing-rules/BillingRuleList.react.js';

/* Flows */
import FlowView from './flows/FlowView.react.js';
import FlowLogger from './flows/FlowLogger.react.js';
import FlowEdit from './flows/FlowEdit.react.js';
import FlowChannelConfig from './flows/FlowChannelConfig.react.js';
import FlowConfig from './flows/FlowConfig.react.js';
import FlowAdd from './flows/FlowAdd.react.js';
import FlowAddStep1 from './flows/FlowAddStep1.react';
import FlowAddStep4 from './flows/FlowAddStep4.react';
import FlowList from './flows/FlowList.react.js';
import FlowHooks from './flows/FlowHooks.react.js';
import FlowCoordination from './flows/FlowCoordination.react.js';
import ScenarioFlowList from './flows/ScenarioFlowList.react.js';
import ChannelErrorListFlow from './channel-errors/ChannelErrorListFlow.react';
import ChannelErrorListUser from './channel-errors/ChannelErrorListUser.react';
import ChannelErrorListConsultant from './channel-errors/ChannelErrorListConsultant.react';
import ChannelErrorListOrganisation from './channel-errors/ChannelErrorListOrganisation.react';
import ChannelErrorList from './channel-errors/ChannelErrorList.react';
import ChannelErrorView from './channel-errors/ChannelErrorView.react';
import ChannelErrorEdit from './channel-errors/ChannelErrorEdit.react';

/* Flow Incoming Emails */
import FlowIncomingEmailView from './flow-incoming-emails/FlowIncomingEmailView.react.js';
import FlowIncomingEmailList from './flow-incoming-emails/FlowIncomingEmailList.react.js';


/* Flow Invocations */
import FlowInvocationView from './flow-invocations/FlowInvocationView.react.js';
import FlowInvocationLogger from './flow-invocations/FlowInvocationLogger.react.js';
import FlowInvocationList from './flow-invocations/FlowInvocationList.react.js';
import FlowInvocationListOrganisation from './flow-invocations/FlowInvocationListOrganisation.react.js';

/* jobs */
import JobList from './jobs/JobList.react.js';
import JobView from './jobs/JobView.react.js';
import ChannelJobList from './jobs/ChannelJobList.react';
import UserJobList from './jobs/UserJobList.react';
import UserJobView from './jobs/UserJobView.react';

/* fetches */
import FetchList from './fetches/FetchList.react.js';
import FetchListOrganisation from './fetches/FetchListOrganisation.react.js';
import FetchListFlow from './fetches/FetchListFlow.react.js';
import FetchListFlowInvocation from './fetches/FetchListFlowInvocation.react.js';
import FetchView from './fetches/FetchView.react.js';
import FetchRetry from './fetches/FetchRetry.react.js';
import FetchOrganisationView from './fetches/FetchOrganisationView.react.js';

/* events */
import EventList from './events/EventList.react.js';
import EventView from './events/EventView.react.js';

/* data sets */
import DataSetView from './data-sets/DataSetView.react.js';
import DataView from './data-sets/DataView.react.js';
import DataSetList from './data-sets/DataSetList.react.js';

/* scenarios */
import ScenarioView from './scenarios/ScenarioView.react.js';
import ScenarioList from './scenarios/ScenarioList.react.js';
import ScenarioApply from './scenarios/ScenarioApply.react';

/* public */
import ChannelDefListForUser from './channel-defs/ChannelDefListForUser.react';
import ChannelDefDetail from './public-repo/ChannelDefDetail.react';
import ScenarioDefDetail from './public-repo/ScenarioDefDetail.react';

/* settings */
import Settings from './settings/Settings.react';

import createRoutesForView from './createRoutesForView';
import createRoutesForAdmin from './createRoutesForAdmin';

import App from './app/App.react';

import NotFound from './app/NotFound.react';

import { renderLoadingPanel } from "./loadingLine/renderLoadingPanel.react";
import DatiQueryTool from "./app/DatiQueryTool.react";
import ChannelErrorDefList from "./channel-errors/ChannelErrorDefList.react.js";
import ChannelErrorDefListOrgReact from './channel-errors/ChannelErrorDefListOrg.react.js';
import ChannelErrorDefListFlowReact from './channel-errors/ChannelErrorDefListFlow.react.js';
import Organisation2UserNotificationsListReact from './organisation2user/Organisation2UserNotificationsList.react.tsx';

let appElement;

export default function createRoutes() {
    return (
        <Route name="⌂" onChange={(prevState, nextState) => {
			if (!appElement) {
				appElement = document.getElementById("app");
			}
			appElement.scrollIntoView();
		}} path="/">
            <Route component={() => { window.close(); return null; }} exact path="login-only" strict />

            <Route path="registration">
                <IndexRedirect to="/"  />
            </Route>

            <Route path="signup">
                <IndexRedirect to="/"  />
            </Route>

            <Route component={App} path="datiquery/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={DatiQueryTool} name="datiQuery.title" queries={meQuery} render={renderLoadingPanel}/>
            </Route>

            <Route component={App} path="channel-granted" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={ChannelGranted} name="channelGranted.title" queries={meQuery} render={renderLoadingPanel}/>
            </Route>

			<Route component={ChannelGrantedInPanel} path="channel-granted-in-panel" queries={meQuery} />

            <Route component={App} path="sign-in/:extensionId/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={SignIn} name="SignIn.title" queries={meQuery} render={renderLoadingPanel}/>
            </Route>

            <Route component={App} path="create-app/:channelDefId/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={ChannelAddStep1} name="channels:createButton" queries={meQuery} render={renderLoadingPanel}/>
            </Route>

            <Route component={App} path="apply-scenario/:scenarioId/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={ScenarioApply} name="scenarios:view" queries={meQuery} render={renderLoadingPanel}/>
            </Route>

            <Route component={App} path="invitation/:invitationId/:secret/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={InvitationAccept} name="invitations:view" queries={meQuery} render={renderLoadingPanel}/>
            </Route>

            <Redirect path="/scenarios/" to="/s/"/>
            <Redirect path="/scenarios" to="/s/"/>
            <Redirect path="/scenarios/:urlFragment/" to="/s/:urlFragment/"/>
            <Redirect path="/scenarios/:urlFragment" to="/s/:urlFragment/"/>

            {/* scenarios */}
            <Route component={App} name="scenarios:list" path="s/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={ScenarioList} queries={meQuery} render={renderLoadingPanel} />

                <Route component={ScenarioList} path="search/:searchName/" queries={meQuery} render={renderLoadingPanel} />

                <Route name="scenarios:view" path=":scenarioUrlFragment/">
                    <IndexRoute component={ScenarioView} queries={meQuery} render={renderLoadingPanel} />

                    <Route name="scenarios.applyScenario" path="apply/">
                        <IndexRoute component={ScenarioApply} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    <Route name="flowList.title" path="flows/">
                        <IndexRoute component={ScenarioFlowList} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    <Route name="organisationsList.title" path="organisations/">
                        <IndexRoute component={ScenarioOrganisationList} queries={meQuery} render={renderLoadingPanel} />
                    </Route>
                </Route>
            </Route>

            <Route component={App} name="scenarioDefs:list" path="s-type/:scenarioDefUrlFragment/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={ScenarioDefDetail} queries={meQuery} render={renderLoadingPanel} />

            </Route>

            {/* apps */}
            <Route component={App} name="appsList.title" path="apps/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={ChannelDefListForUser} queries={meQuery} render={renderLoadingPanel} />

                <Route name="channelDefs:view" path=":channelDefUrlFragment/">
                    <IndexRoute component={ChannelDefDetail} queries={meQuery} render={renderLoadingPanel} />

                    <Route component={ChannelAddStep1} name="channels:createButton" path="add/" queries={meQuery} render={renderLoadingPanel} />
                    <Route component={ChannelAddAuto} name="channels:createButton" path="add/auto/" queries={meQuery} render={renderLoadingPanel} />
                </Route>
            </Route>


            <Route name="organisations:list" path="organisations/">
                <Route component={App} queries={meQuery} render={renderLoadingPanel}>
                    <IndexRoute component={OrganisationList} queries={meQuery} render={renderLoadingPanel} />
                    <Route component={OrganisationAdd} name="organisationAdd.title" path="add" queries={meQuery} render={renderLoadingPanel} />
                </Route>

                <Route component={App} name="organisations:view" path=":organisationId/" queries={meQuery} render={renderLoadingPanel}>
                    <IndexRoute component={OrganisationView} queries={meQuery} render={renderLoadingPanel} />
                    <Route component={OrganisationEdit} path="edit" queries={meQuery} render={renderLoadingPanel} />

                    <Route component={UsedScenarioList} path="used-scenarios/" queries={meQuery} render={renderLoadingPanel} />

                    <Route component={Organisation2UserEdit} name="organisation2user:view" path="organisation2user/:organisations2userId/" queries={meQuery} render={renderLoadingPanel} />

                    <Route name="fetchList.title" path="fetches/">
                        <IndexRoute component={FetchListOrganisation} prepareParams={(params) => Object.assign(params, {success: null})} queries={meQuery} render={renderLoadingPanel} />

                        <Route name="fetches:view" path=":fetchId/">
                            <IndexRoute component={FetchOrganisationView} queries={meQuery} render={renderLoadingPanel} />
                        </Route>
                    </Route>
                    <Route name="RunningJobsList2.title" path="running-jobs/">
                        <IndexRoute component={OrganisationRunningJobList} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    <Route name="fetchList.title" path="fetches-:success/">
                        <IndexRoute component={FetchListOrganisation} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    {/* billing */}
                    <Route name="billingList.title" path="billing/">
                        <IndexRoute component={OrganisationBilling} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    {/* tariffs */}
                    <Route name="tariffList.title" path="tariffs/">
                        <IndexRoute component={TariffList} queries={meQuery} render={renderLoadingPanel} />
                        <Route component={TariffAdd} name="tariffAdd.title" path="add" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={TariffEdit} path=":id/edit/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={TariffEdit} path=":id/view/" queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    {/* invoices */}
                    <Route name="invoices:list" path="invoices/">
                        <IndexRoute component={OverdueBillsPage} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    <Route name="channelErrors.title" path="channel-errors/">
                        <IndexRoute
                            component={ChannelErrorListOrganisation}
                            prepareParams={(params) => Object.assign(params, { success: null })}
                            queries={meQuery}
                            render={renderLoadingPanel}
                        />
                    </Route>
                    <Route name="channelErrors.title" path="channel-errors-type/">
                        <IndexRoute
                            component={ChannelErrorDefListOrgReact}
                            isOrgView
                            prepareParams={(params) => Object.assign(params, { success: null })}
                            queries={meQuery}
                            render={renderLoadingPanel}
                        />
                    </Route>
                    <Route name="channelErrors.title" path="channel-errors-:success/">
                        <IndexRoute component={ChannelErrorListOrganisation} queries={meQuery} render={renderLoadingPanel} />
                    </Route>


                    {/* hooks */}
                    <Route name="flowHooks.title" path="hooks/">
                        <IndexRoute component={OrganisationHooks} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    {/* organisation events */}
                    <Route name="billingList.title" path="events/">
                        <IndexRoute component={OrganisationEventList} queries={meQuery} render={renderLoadingPanel} />
                    </Route>


                    {/* organisation notifications */}
                    <Route name="organisationNotificationView.title" path="notifications/">
                        <IndexRoute component={OrganisationNotificationList} queries={meQuery} render={renderLoadingPanel} />

                        <Route name="organisationNotificationView.title" path=":notificationId/">
                                    <IndexRoute component={OrganisationNotificationView} queries={meQuery} render={renderLoadingPanel} />
                        </Route>

                    </Route>


                    {/* channels */}
                    <Route name="channels:list" path="channels/">
                        <IndexRedirect to="/organisations/:organisationId/"  />

                        <Route component={ChannelAdd} path="add" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={ChannelAddStep1} path="add-step/1/:channelDefId/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={ChannelAddStep2} path="add-step/2/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={ChannelAddStep3} path="add-step/3/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={ChannelAddStep4} path="add-step/4/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={ChannelAddStep5} path="add-step/5/:channelId/" queries={meQuery} render={renderLoadingPanel} />

                        <Route name="scenarios:view" path="scenarios/:scenarioId/">
                            <Route component={ChannelAddStep1} path="add-step/1/:channelDefId/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelAddStep2} path="add-step/2/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelAddStep3} path="add-step/3/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelAddStep4} path="add-step/4/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelAddStep5} path="add-step/5/:channelId/" queries={meQuery} render={renderLoadingPanel} />
                        </Route>


						<Route name="scenarios:view" path="scenarios/:scenarioUrlFragment/:scenarioId/">
							<Route component={ScenarioApply} path="apply/" queries={meQuery} render={renderLoadingPanel} />
						</Route>

                        <Route name="channels:view" path=":channelId/">
                            <IndexRoute component={ChannelView} queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelEdit} name="channelEdit.title" path="edit" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelLogger} name="logger.title" path="logger" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ChannelOptionEdit} name="channelOptionEdit.title" path="options" queries={meQuery} render={renderLoadingPanel}/>
                            <Route component={SetChannelConfidential} name="channelConfidential.title" path="confidential" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={ActivateChannelCaching} name="activateChannelCaching.title" path="caching" queries={meQuery} render={renderLoadingPanel} />

                            <Route
                                app="shoptet"
                                component={ApplicationAddonDetail}
                                name="applicationAddonDetail.title"
                                path="shoptet"
                                queries={meQuery}
                                render={renderLoadingPanel}
                            />
                            <Route
                                app="upgates"
                                component={ApplicationAddonDetail}
                                name="applicationAddonDetail.title"
                                path="upgates"
                                queries={meQuery}
                                render={renderLoadingPanel}
                            />

                            {/* organisation events */}
                            <Route name="billingList.title" path="events/">
                                <IndexRoute component={ChannelEventList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>

                            {/* fetches */}
                            <Route name="fetchList.title" path="fetches/">
                                <IndexRoute component={FetchList} prepareParams={(params) => Object.assign(params, {success: null})} queries={meQuery} render={renderLoadingPanel} />

                                <Route name="fetchView.title" path=":fetchId/">
                                    <IndexRoute component={FetchView} queries={meQuery} render={renderLoadingPanel} />

                                    <Route name="fetchRetry.title" path="retry/">
                                        <IndexRoute component={FetchRetry} queries={meQuery} render={renderLoadingPanel} />
                                    </Route>
                                </Route>
                            </Route>

                            <Route name="fetchList.title" path="fetches-:success/">
                                <IndexRoute component={FetchList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>

                            {/* channel-errors */}
                            <Route name="channelErrors.title" path="channel-errors/">
                                <IndexRoute component={ChannelErrorList} prepareParams={(params) => Object.assign(params, {success: null})} queries={meQuery} render={renderLoadingPanel} />

                                <Route name="channelErrorView.title" path=":channelErrorId/">
                                    <IndexRoute component={ChannelErrorView} queries={meQuery} render={renderLoadingPanel} />

                                    <Route component={ChannelErrorEdit} name="channelErrorEdit.title" path="edit/" queries={meQuery} render={renderLoadingPanel} />
                                </Route>
                            </Route>

                            <Route name="channelErrors.title" path="channel-errors-:success/">
                                <IndexRoute component={ChannelErrorList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>


                            {/* jobs */}
                            <Route name="jobList.title" path="jobs/">
                                <IndexRoute component={ChannelJobList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>


                            {/* data set */}
                            <Route name="dataSets:list" path="data-sets/">
                                <IndexRoute component={DataSetList} queries={meQuery} render={renderLoadingPanel} />

                                <Route name="dataSets:view" path=":dataSetId/">
                                    <IndexRoute component={DataSetView} queries={meQuery} render={renderLoadingPanel} />

                                    <Route name="dataSets:view" path=":keyId/">
                                        <IndexRoute component={DataView} queries={meQuery} render={renderLoadingPanel} />
                                    </Route>

                                </Route>
                            </Route>

                            {/* events */}
                            <Route name="eventList.title" path="events/">
                                <IndexRoute component={EventList} queries={meQuery} render={renderLoadingPanel} />

                                <Route name="eventView.title" path=":eventId/">
                                    <IndexRoute component={EventView} queries={meQuery} render={renderLoadingPanel} />
                                </Route>
                            </Route>

                            {/* screens */}
                            <Route name="screenList.title" path="screens/">
                                <IndexRoute component={ScreenList} queries={meQuery} render={renderLoadingPanel} />
                                <Route component={ScreenAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />

                                <Route name="screens:view" path=":screenId/">
                                    <IndexRoute component={ScreenView} queries={meQuery} render={renderLoadingPanel} />
                                    <Route component={ScreenEdit} name="screenEdit.title" path="edit/" queries={meQuery} render={renderLoadingPanel} />
                                </Route>
                            </Route>

                            {/* channel addons */}
                            <Route name="channelAddonList.title" path="addons/">
                                <IndexRoute component={ChannelAddonList} queries={meQuery} render={renderLoadingPanel} />
                                <Route component={ChannelAddonAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />
                                <Route component={ChannelAddonAddStep1} path="add-step/1/:addonDefId/" queries={meQuery} render={renderLoadingPanel} />
                                <Route component={ChannelAddonAddStep2} path="add-step/2/:addonDefId/" queries={meQuery} render={renderLoadingPanel} />

                                <Route name="channelAddons:view" path=":channelAddonId/">
                                    <IndexRoute component={ChannelAddonView} queries={meQuery} render={renderLoadingPanel} />
                                    <Route component={ChannelAddonEdit} name="channelAddonEdit.title" path="edit/" queries={meQuery} render={renderLoadingPanel} />
                                    <Route component={ChannelAddonConfig} name="channelAddonConfig.title" path="config/" queries={meQuery} render={renderLoadingPanel} />
                                </Route>
                            </Route>

                        </Route>
                    </Route>

                    {/* relation Def */}
                    <Route name="relationDefList.title" path="relations/">
                        <IndexRoute component={RelationDefList} queries={meQuery} render={renderLoadingPanel} />
                        <Route component={RelationDefAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />

                        <Route name="relationDefs:view" path=":relationDefId/">
                            <IndexRoute component={RelationDefView} queries={meQuery} render={renderLoadingPanel} />
                            <Route component={RelationDefEdit} name="relationDefEdit.title" path="edit/" queries={meQuery} render={renderLoadingPanel} />
                        </Route>
                    </Route>

                    {/* billing Rules */}
                    <Route name="billingRuleList.title" path="billing-rules/">
                        <IndexRoute component={BillingRuleList} queries={meQuery} render={renderLoadingPanel} />
                        <Route component={BillingRuleAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />

                        <Route name="billingRules:view" path=":billingRuleId/">
                            <IndexRoute component={BillingRuleView} queries={meQuery} render={renderLoadingPanel} />
                            <Route component={BillingRuleEdit} name="billingRuleEdit.title" path="edit/" queries={meQuery} render={renderLoadingPanel} />
                        </Route>
                    </Route>

                    {/* flow invocation list */}
                    <Route name="flowInvocationsList.title" path="invocations/">
                        <IndexRoute component={FlowInvocationListOrganisation} prepareParams={(params) => Object.assign(params, {failed: null})} queries={meQuery} render={renderLoadingPanel} />
                    </Route>

                    <Route name="flowInvocationsList.title" path="invocations-:failed/">
                        <IndexRoute component={FlowInvocationListOrganisation} queries={meQuery} render={renderLoadingPanel} />
                    </Route>


                    {/* flows */}
                    <Route name="flowList.title" path="flows/">
                        <IndexRoute component={FlowList} queries={meQuery} render={renderLoadingPanel} />
                        <Route component={FlowAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={FlowAddStep1} path="add-step/1/:flowDefId/" queries={meQuery} render={renderLoadingPanel} />
                        <Route component={FlowAddStep4} path="add-step/4/:flowId/" queries={meQuery} render={renderLoadingPanel} />

                        <Route name="flows:view" path=":flowId/">
                            <IndexRoute component={FlowView} queries={meQuery} render={renderLoadingPanel} />
                            <Route component={FlowEdit} name="FlowEdit.title" path="edit/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={FlowLogger} name="logger.title" path="logger/" queries={meQuery} render={renderLoadingPanel} />

                            <Route component={FlowChannelConfig} name="FlowChannelConfig.title" path="channel-config/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={FlowConfig} name="flowConfig.title" path="config/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={FlowHooks} name="flowHooks.title" path="hooks/" queries={meQuery} render={renderLoadingPanel} />
                            <Route component={FlowCoordination} name="FlowCoordination.title" path="coordinations/" queries={meQuery} render={renderLoadingPanel} />

                            <Route name="fetchList.title" path="fetches/">
                                <IndexRoute component={FetchListFlow} prepareParams={(params) => Object.assign(params, {success: null})} queries={meQuery} render={renderLoadingPanel} />
                            </Route>
                            <Route name="fetchList.title" path="fetches-:success/">
                                <IndexRoute component={FetchListFlow} queries={meQuery} render={renderLoadingPanel} />
                            </Route>

                            <Route name="channelErrors.title" path="channel-errors/">
                                <IndexRoute
                                    component={ChannelErrorListFlow}
                                    prepareParams={(params) => Object.assign(params, { success: null })}
                                    queries={meQuery}
                                    render={renderLoadingPanel}
                                />
                            </Route>
                            <Route name="channelErrors.title" path="channel-errors-type/">
                                <IndexRoute
                                    component={ChannelErrorDefListFlowReact}
                                    isFlowView
                                    prepareParams={(params) => Object.assign(params, { success: null })}
                                    queries={meQuery}
                                    render={renderLoadingPanel}
                                />
                            </Route>
                            <Route name="channelErrors.title" path="channel-errors-:success/">
                                <IndexRoute component={ChannelErrorListFlow} queries={meQuery} render={renderLoadingPanel} />
                            </Route>

                            {/* flow events */}
                            <Route name="billingList.title" path="events/">
                                <IndexRoute component={FlowEventList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>

                            <Route name="flowIncomingEmailList.title" path="emails-:type/">
                                <IndexRoute component={FlowIncomingEmailList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>
                            <Route name="flowIncomingEmailList.title" path="emails/">
                                <IndexRoute component={FlowIncomingEmailList} prepareParams={(params) => Object.assign(params, {type: null})} queries={meQuery} render={renderLoadingPanel} />

                                <Route name="flowIncomingEmails:view" path=":flowIncomingEmailId/">
                                    <IndexRoute component={FlowIncomingEmailView} queries={meQuery} render={renderLoadingPanel} />
                                </Route>
                            </Route>

                            <Route name="flowInvocationsList.title" path="invocations/">
                                <IndexRoute component={FlowInvocationList} prepareParams={(params) => Object.assign(params, {failed: null})} queries={meQuery} render={renderLoadingPanel} />

                                <Route name="flowInvocations:view" path=":flowInvocationId/">
                                    <IndexRoute component={FlowInvocationView} queries={meQuery} render={renderLoadingPanel} />

                                    <Route name="logger.title" path="logger/">
                                        <IndexRoute component={FlowInvocationLogger} queries={meQuery} render={renderLoadingPanel} />
                                    </Route>
                                    <Route name="fetchList.title" path="fetches/">
                                        <IndexRoute component={FetchListFlowInvocation} prepareParams={(params) => Object.assign(params, {success: null})} queries={meQuery} render={renderLoadingPanel} />
                                    </Route>
                                    <Route name="fetchList.title" path="fetches-:success/">
                                        <IndexRoute component={FetchListFlowInvocation} queries={meQuery} render={renderLoadingPanel} />
                                    </Route>
                                </Route>
                            </Route>
                            <Route name="flowInvocationsList.title" path="invocations-:failed/:startType/">
                                <IndexRoute component={FlowInvocationList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>
                            <Route name="flowInvocationsList.title" path="invocations-:failed/">
                                <IndexRoute component={FlowInvocationList} queries={meQuery} render={renderLoadingPanel} />
                            </Route>
                        </Route>
                    </Route>

                    {/* jobs */}
                    <Route name="jobList.title" path="jobs/">
                        <IndexRoute component={JobList} queries={meQuery} render={renderLoadingPanel} />

                        <Route name="jobs:view" path=":jobId/">
                            <IndexRoute component={JobView} queries={meQuery} render={renderLoadingPanel} />
                        </Route>
                    </Route>

                    {/* Users */}
                    <Route name="userList.title" path="users/">
                        <IndexRoute component={Organisation2UserList} queries={meQuery} render={renderLoadingPanel} />

                        <Route name="users:view" path=":userId/">
                            <IndexRoute component={UserView} queries={meQuery} render={renderLoadingPanel} />
                            <Route component={UserEdit} path="edit" queries={meQuery} render={renderLoadingPanel} />

                            {/* api keys */}
                            <Route name="apiKeyList.title" path="api-keys/">
                                <IndexRoute component={ApiKeyList} queries={meQuery} render={renderLoadingPanel} />
                                <Route component={ApiKeyAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />

                                <Route name="apiKeys:view" path=":apiKeyId/">
                                    <IndexRoute component={ApiKeyView} queries={meQuery} render={renderLoadingPanel} />
                                    <Route component={ApiKeyEdit} path="edit/" queries={meQuery} render={renderLoadingPanel} />
                                </Route>
                            </Route>
                        </Route>
                    </Route>

                    {/* invitations */}
                    <Route name="invitationList.title" path="invitations/">
                        <IndexRoute component={InvitationList} queries={meQuery} render={renderLoadingPanel} />
                        <Route component={InvitationAdd} path="add/" queries={meQuery} render={renderLoadingPanel} />

                        <Route name="invitations:view" path=":invitationId/">
                            <IndexRoute component={InvitationView} queries={meQuery} render={renderLoadingPanel} />
                        </Route>
                    </Route>

                </Route>
            </Route>


            {/* jobs */}
            <Route component={App} name="jobList.title" path="jobs/" queries={meQuery} render={renderLoadingPanel}>
                <IndexRoute component={UserJobList} queries={meQuery} render={renderLoadingPanel} />

                <Route name="jobList:view" path=":jobId/">
                    <IndexRoute component={UserJobView} queries={meQuery} render={renderLoadingPanel} />
                </Route>
            </Route>

            <Route component={App} path="settings/" queries={meQuery} render={renderLoadingPanel}>
				<IndexRoute component={Settings} queries={meQuery} render={renderLoadingPanel} />

                <Route name="organisationNotificationView.title" path="consultants/notifications/">
                    <IndexRoute component={ConsultantNotificationList} queries={meQuery} render={renderLoadingPanel} />
                </Route>

                <Route name="organisationNotificationView.title" path="notifications/">
                    <IndexRoute component={Organisation2UserNotificationsListReact} queries={meQuery} render={renderLoadingPanel} />
                </Route>

                <Route name="channelErrors.title" path="consultants/channel-errors/">
                    <IndexRoute component={ChannelErrorListConsultant} prepareParams={(params) => Object.assign(params, {success: null})} queries={meQuery} render={renderLoadingPanel} />
                </Route>
                <Route name="channelErrors.title" path="consultants/channel-errors-:success/">
                    <IndexRoute component={ChannelErrorListConsultant} queries={meQuery} render={renderLoadingPanel} />
                </Route>

                <Route name="channelErrors.title" path="channel-errors/">
                    <IndexRoute
                        component={ChannelErrorListUser}
                        prepareParams={(params) => Object.assign(params, { success: null })}
                        queries={meQuery}
                        render={renderLoadingPanel}
                    />
                </Route>
                <Route name="channelErrors.title" path="channel-errors-type/">
                    <IndexRoute
                        component={ChannelErrorDefList}
                        prepareParams={(params) => Object.assign(params, { success: null })}
                        queries={meQuery}
                        render={renderLoadingPanel}
                    />
                </Route>
                <Route name="channelErrors.title" path="channel-errors-type-:success/">
                    <IndexRoute component={ChannelErrorListUser} queries={meQuery} render={renderLoadingPanel} />
                </Route>
                <Route name="channelErrors.title" path="channel-errors-:success/">
                    <IndexRoute component={ChannelErrorListUser} queries={meQuery} render={renderLoadingPanel} />
                </Route>

				<Route name="edit" path="edit/">
                    <IndexRoute component={UserEdit} queries={meQuery} render={renderLoadingPanel} />
                </Route>
			</Route>

            <Route path="" render={renderLoadingPanel}>
                <IndexRoute component={HomePage} queries={meQuery} render={renderLoadingPanel} />
            </Route>

            {createRoutesForView()}
            {createRoutesForAdmin()}

            <Route component={NotFound} name="404: Not Found" path="*" />
        </Route>
    );
}
